export const getCurrentEnvironment = (state) => () => {
  return localStorage.getItem('environment');
};

export const groupedAlerts = (state) => {
  var alerts = state.alerts;
  if ((alerts || null) === null) {
    return null;
  }

  // Todo - Move to insertion time, not retrieval
  alerts.sort((x, y) => {
    var xDate = new Date(x.startTime);
    var yDate = new Date(y.startTime);

    if (xDate < yDate) return 1;
    else if (xDate > yDate) return -1;
    else return 0;
  });

  var grouped = [];
  alerts.forEach(x => {
    var idx = grouped.findIndex((element) => {
      var a = new Date(x.startTime).toLocaleDateString('en-US', state.statusGroupDateFormat);
      return element.group === a;
    });

    if (idx >= 0) {
      grouped[idx].alerts.push(x);
    } else {
      grouped.push({
        group: new Date(x.startTime).toLocaleDateString('en-US', state.statusGroupDateFormat),
        alerts: [x]
      });
    }
  });

  grouped.sort((x, y) => {
    var xDate = new Date(x.group);
    var yDate = new Date(y.group);

    if (xDate < yDate) {
      return 1;
    } else if (xDate > yDate) {
      return -1;
    } else return 0;
  });

  return grouped;
};
